import Crum from '@/components/Crum';
import PageLayout from '@/components/PageLayout';
import { Collapse as AntCollapse } from 'antd';
import dynamic from 'next/dynamic';
import css from './index.module.scss';
//import SupportBanner from '@/components/SupportCommon/SupportBanner';
import SupportBannerH5 from '@/componentsH5/SupportCommon/SupportBanner';
//import SupportContactUs from '@/components/SupportCommon/SupportContactUs';
import { YouTubeVideoPlayer } from '@/components/ProductDetailComponents';
import Collapse from '@/components/UI/Collapse';
import Image from '@/components/UI/Image';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import { EFBattery, EFNote, EFTimer } from '@/components/UI/svg/Search';
import SupportContactUsH5 from '@/componentsH5/SupportCommon/SupportContactUs';
import { getDownloadInfo, getFaqs } from '@/service';
import { isReadyLang, redirectTo404 } from '@/utils';
import generatorPlayUrl from '@/utils/generatorPlayUrl';
import { useGlobal } from '@/utils/useGlobal';
const SupportBanner = dynamic(() => import('@/components/SupportCommon/SupportBanner'), {
    ssr: true,
});
const SupportContactUs = dynamic(() => import('@/components/SupportCommon/SupportContactUs'), {
    ssr: true,
});

export default function SupportFaq({ SEO, query, lang, downloadData, faqData }: any) {
    const { useState, useEffect, gloproductlist, isMobile, useLang, gtm } = useGlobal();
    const { t } = useLang('shared');
    const currSpu = gloproductlist?.find((item: any) => item.spuId === query?.categoryId);
    const spuName = currSpu?.name || '';
    const [activeKeyData, setActiveKeyData] = useState({
        activeKey: '',
        hoverKey: '',
        left: 0,
    });
    const [faqDataList, setFaqDataList] = useState([]);
    const [videoList, setVideoList] = useState([]);
    const [currentVideo, setCurrentVideo] = useState({
        isShow: false,
        videoUrl: '',
    });
    const [faqActiveKey, setFaqActiveKey] = useState(0);

    const onChange = (key: any) => {
        setFaqActiveKey(key);
        const filterItem = faqDataList.find((v: any) => v.key === (key ? key : faqActiveKey));
        if (filterItem) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'select_faq',
                title_name: filterItem.text,
                status: key ? 'Open' : 'Close',
            });
        }
    };

    const tabList = [
        // tab
        {
            key: 'PRODUCT_RELATED',
            text: isMobile ? lang.site_support_product_faq_introduction_h5 : lang.site_support_product_faq_introduction,
            icons: isMobile ? '/icons/secondh5.svg' : '/icons/second.svg',
            hicons: isMobile ? '/icons/secondh5.svg' : '/icons/second-hover.svg',
            h5icons: <EFTimer />,
            list: ['RIVER mini', 'RIVER ', 'RIVER pro', 'RIVER max'],
        },
        {
            key: 'FAULT',
            text: lang.site_support_product_faq_troubleshooting,
            icons: isMobile ? '/icons/hooth5.svg' : '/icons/hoot.svg',
            hicons: isMobile ? '/icons/hooth5.svg' : '/icons/hoot-hover.svg',
            h5icons: <EFBattery />,
            list: ['RIVER1 mini', 'RIVER5 mini', 'DELTA pro', 'RIVER6 mini'],
        },
        {
            key: 'NOTE',
            text: lang.site_support_product_faq_note,
            icons: isMobile ? '/icons/noteh5.svg' : '/icons/note.svg',
            hicons: isMobile ? '/icons/noteh5.svg' : '/icons/note-hover.svg',
            h5icons: <EFNote />,
            list: ['DELTA mini', 'DELTA 300', ',DELTA77 mini', 'DELTA mx'],
        },
    ];

    tabList.forEach((tab: any) => {
        tab.subs = faqData?.data?.content
            ?.filter((item: any) => item.typeTag === tab.key)
            ?.map((faq: any) => ({
                key: faq.faqInfoId,
                text: faq.title,
                value: faq.description,
            }));
    });

    const breadcrumbData = [
        { name: t('crums.crum_home'), link: '/' },
        { name: t('crums.crum_support'), link: '/support' },
        { name: t('crums.crum_product_support'), link: '/support' },
        { name: spuName },
    ];

    /**
     * 获取faq列表
     * @param typeTag
     */
    const getFaqList = (typeTag: string) => {
        if (faqData?.code === '0') {
            setFaqDataList(
                faqData.data?.content
                    ?.filter((item: any) => item.typeTag === typeTag)
                    ?.map((faq: any) => ({
                        key: faq.faqInfoId,
                        text: faq.title,
                        value: faq.description,
                    })),
            );
        }
    };

    /**
     * 点击播放视频
     * @param e
     */
    const handlePlayVideo = (e: any) => {
        const target = e.target?.closest('.mask');
        if (!target?.classList.contains('play')) return;
        const { url, isYoutube, title, index } = target.dataset;
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: title,
            position: `Tutorial Videos_${parseFloat(index) + 1}`,
        });
        if (isYoutube === 'true') {
            setCurrentVideo({ url, isShow: true });
        } else {
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.click();
        }
    };

    /**
     * 关闭播放视频
     */
    const closeVideo = () => {
        setCurrentVideo({ url: '', isShow: false });
    };

    /**
     * 切换tab，更新faq列表
     * @param activeKey
     * @param e
     */
    const TabChange = (activeKey: string, e: any, text: string) => {
        if (e) {
            const dom = e.target.closest('.tab');
            if (!dom) return;
            const { offsetLeft } = dom;
            setActiveKeyData({ activeKey, left: offsetLeft });
            gtm.push({
                event: 'uaEvent',
                event_name: 'faq_navigation',
                navigation_name: text,
            });
        }
        if (isMobile) {
            setActiveKeyData({ activeKey, left: 0 });
            gtm.push({
                event: 'uaEvent',
                event_name: 'faq_navigation',
                navigation_name: text,
            });
        }
        getFaqList(activeKey);
    };

    const onMouseEnter = (hoverKey: string, e: any) => {
        const dom = e.target;
        if (dom.classList.contains('tab')) return;
        setActiveKeyData({ ...activeKeyData, hoverKey });
    };

    const onMouseLeave = (e: any) => {
        const dom = e.target;
        if (dom.classList.contains('tab')) return;
        setActiveKeyData({ ...activeKeyData, hoverKey: '' });
    };

    useEffect(() => {
        if (query) {
            if (downloadData?.code === '0') {
                // 0515 @陈琨说 视频顺序反了（与详情页中对比）
                setVideoList(downloadData.data?.content.reverse() || []);
            }
        }
    }, [query]);

    return (
        <PageLayout>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <div className={`${css.supportFaq}`}>
                <div className={`${isMobile ? 'support-banner-h5' : 'support-banner-pc'}`}>
                    {isMobile ? (
                        <SupportBannerH5
                            isSearch={true}
                            title={`${lang.site_support_product_tit} \n ${spuName}`}
                            subTitle={lang.supbanner_prd_subtit_h5}
                            isSupport={true}
                            singleShow={false}
                            titleShow={true}
                            subTitleShow={false}
                        />
                    ) : (
                        <SupportBanner
                            isSearch={false}
                            title={`${lang.site_support_product_tit} ${spuName}`}
                            singleShow={true}
                            titleShow={false}
                            subTitleShow={false}
                        />
                    )}
                </div>
                <div className="bannerImgs"></div>
                <Crum data={breadcrumbData} />
                <div className="container">
                    {/* {lang.title} */}
                    <div className="accessories-box">
                        <h2 className="title font-family-semibold">{lang.site_support_product_faq}</h2>
                        {!isMobile ? (
                            <div className="content">
                                <div className="tabsContent">
                                    <ul className={`tabs ${activeKeyData.activeKey ? 'showBorder' : ''}`}>
                                        {tabList.map((tab: any) => (
                                            <li
                                                key={tab.key}
                                                className={`tab ${activeKeyData.activeKey === tab.key ? 'active' : ''} ${
                                                    activeKeyData.hoverKey === tab.key ? 'hover' : ''
                                                }`}
                                                onClick={() => TabChange(tab.key, event, tab.text)}
                                                onMouseEnter={() => onMouseEnter(tab.key, event)}
                                                onMouseLeave={onMouseLeave}
                                            >
                                                <div className="img">
                                                    <Image
                                                        src={activeKeyData.activeKey === tab.key || activeKeyData.hoverKey === tab.key ? tab.hicons : tab.icons}
                                                        width={60}
                                                        height={60}
                                                        alt={tab.text}
                                                    />
                                                </div>
                                                <p className="text font-family-regular">{tab.text}</p>
                                            </li>
                                        ))}
                                    </ul>
                                    <div
                                        className="line"
                                        style={{
                                            visibility: activeKeyData.activeKey ? 'visible' : 'hidden',
                                            left: activeKeyData.left,
                                        }}
                                    >
                                        <Image src="/icons/line.svg" width={270} height={10} alt={t('faqs.line')} />
                                    </div>
                                </div>
                                <Collapse
                                    onChange={onChange}
                                    defaultActiveKey={['1']}
                                    expandIcon={({ isActive }) => (
                                        <span
                                            style={{
                                                transform: isActive ? 'rotate(0deg)' : 'rotate(-90deg)',
                                            }}
                                        >
                                            <Image src="/icons/left-arrow.svg" width="12" height="12" alt={t('faqs.icon')} />
                                        </span>
                                    )}
                                    expandIconPosition={'right'}
                                    data={faqDataList}
                                    className="custom-collapse font-family-regular"
                                    accordion
                                />
                            </div>
                        ) : (
                            <AntCollapse
                                onChange={onChange}
                                bordered={true}
                                expandIcon={({ isActive }) => (
                                    <div
                                        style={{
                                            transform: isActive ? 'rotate(-180deg)' : 'rotate(0deg)',
                                            transition: 'all .3s',
                                            lineHeight: 0,
                                        }}
                                    >
                                        <EFArrowDown />
                                    </div>
                                )}
                                expandIconPosition="right"
                                className={'faq-collapse'}
                            >
                                {tabList.map((tab: any, k: number) => (
                                    <AntCollapse.Panel
                                        className="site-collapse-custom-panel"
                                        header={tab.text}
                                        key={tab.key}
                                        extra={<div className="iconLeftBox">{tab.h5icons}</div>}
                                    >
                                        {!!tab?.subs?.length ? (
                                            <Collapse
                                                defaultActiveKey={['1']}
                                                expandIcon={({ isActive }) => (
                                                    <span
                                                        style={{
                                                            transform: isActive ? 'rotate(-180deg)' : 'rotate(0deg)',
                                                            transition: 'all .3s',
                                                        }}
                                                    >
                                                        <Image src="/icons/left-arrow.svg" width="12" height="12" alt={t('faqs.icon')} />
                                                    </span>
                                                )}
                                                expandIconPosition={'right'}
                                                data={tab.subs}
                                                className="custom-collapse font-family-regular"
                                                accordion
                                            />
                                        ) : (
                                            <div className="no-data">
                                                <div className="img-wrapper">
                                                    <Image src="/img/mobile/my/no-data-icon.png" layout="fill" alt={t('faqs.no_data')}></Image>
                                                </div>
                                                <p className="desc">{t('faqs.no_data')}</p>
                                            </div>
                                        )}
                                    </AntCollapse.Panel>
                                ))}
                            </AntCollapse>
                        )}
                        <h2 className="title font-family-semibold" style={{ display: videoList?.length ? 'block' : 'none' }}>
                            {lang.site_support_product_videos}
                        </h2>
                        <div className="videoList">
                            <ul onClick={handlePlayVideo}>
                                {videoList.map((videoItem: any, index: number) => (
                                    <li key={videoItem.downloadInfoId}>
                                        <div className="videos">
                                            <div
                                                data-url={generatorPlayUrl(videoItem.fileUrl).url}
                                                data-is-youtube={generatorPlayUrl(videoItem.fileUrl).isYouTubeVideo}
                                                data-index={index}
                                                data-title={videoItem.title}
                                                className={`play mask ${videoItem?.poster ? 'poster' : ''}`}
                                            >
                                                <Image
                                                    src={videoItem?.poster || generatorPlayUrl(videoItem.fileUrl).imageUrl}
                                                    layout="fill"
                                                    alt={videoItem.title}
                                                />
                                                <div className="play">
                                                    <Image src="/icons/play-support.svg" layout="fill" alt={t('faqs.play_icon')} />
                                                </div>
                                            </div>
                                        </div>
                                        <p data-url={videoItem.fileUrl} className="play font-family-regular">
                                            {videoItem.title}
                                        </p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    {isMobile ? <SupportContactUsH5 /> : <SupportContactUs isShow={true} />}
                </div>
                <YouTubeVideoPlayer floatVideo={currentVideo.isShow} setFloatVideo={closeVideo} videoSrc={`${currentVideo.url}?autoplay=1`} />
            </div>
        </PageLayout>
    );
}

export async function getServerSideProps({ params, locale }: any) {
    if (!isReadyLang(locale)) {
        return redirectTo404(locale);
    }

    const { name } = params;
    const [productName, categoryId] = name;

    let downloadData;
    let faqData = null;
    try {
        faqData = await getFaqs({ spuIds: categoryId }, locale);
        downloadData = await getDownloadInfo(
            {
                classify: 'VIDEO_COURSE',
                orderType: 'TIME_DESC',
                spuIds: categoryId,
            },
            locale,
        );
    } catch (e) {
        console.error(e);
    }

    if (!faqData) {
        return {
            notFound: true,
        };
    }

    return {
        props: {
            query: {
                productName,
                categoryId,
            },
            downloadData: downloadData || {},
            faqData: faqData,
        },
    };
}
